import type { ID } from '@/model/Common.model';
import type { MetadataField } from '@/model/Metadata.model';

const findById = (id: ID | null | undefined, metadata: Array<MetadataField>): MetadataField | undefined =>
  metadata.find((item) => item.id === id);

export const isTextField = (id: ID | null | undefined, metadata: Array<MetadataField>): boolean =>
  findById(id, metadata)?.field_type.toLowerCase() === 'text';

export const isSelectField = (id: ID | null | undefined, metadata: Array<MetadataField>): boolean =>
  findById(id, metadata)?.field_type.toLowerCase() === 'select';

export const isMultiSelectField = (id: ID | null | undefined, metadata: Array<MetadataField>): boolean =>
  findById(id, metadata)?.field_type.toLowerCase() === 'multi_select';

export const isDateField = (id: ID | null | undefined, metadata: Array<MetadataField>): boolean =>
  findById(id, metadata)?.field_type.toLowerCase() === 'date';

export const isLookupSelectField = (id: ID | null | undefined, metadata: Array<MetadataField>): boolean => {
  const fieldType = findById(id, metadata)?.field_type.toLowerCase();
  return fieldType === 'lookup_select' || fieldType === 'lookup_multi_select';
};
